import type { Part, PartNo, PropertyConfigCode } from "@/features/sub-families/types";
import { getPartDescriptor } from "@/features/sub-families/utils/parts.ts";
import { smartNumberChangeMultipleColoursAction } from "@/redux/slices/smart-number-slice.ts";
import { useAppDispatch, useAppSelector } from "@/redux/store.ts";
import type { SmartNumberDescriptorKey } from "@/types";

export default function useParts() {
    const dispatch = useAppDispatch();
    const parts = useAppSelector((state) => state.parts.items);

    const individualEditableParts = parts?.filter((part) => !part.followsPartNo) ?? [];

    const selectFinishingColour = (
        part: Part,
        descriptor: SmartNumberDescriptorKey,
        configCode: PropertyConfigCode,
    ) => {
        const additionalParts = findPartsThatFollowPartNo(part.partNo, parts);

        const descriptors = [descriptor];
        for (const additionalPart of additionalParts) {
            descriptors.push(getPartDescriptor(additionalPart));
        }

        dispatch(smartNumberChangeMultipleColoursAction({ descriptors, value: configCode }));
    };

    return { allowedParts: individualEditableParts, selectFinishingColour };
}

function findPartsThatFollowPartNo(partNo: PartNo, parts: Part[]) {
    return parts.filter((part) => part.followsPartNo === partNo);
}
